import { Environments } from '../components';

export const getEnvironmentName = (name: string): string =>
  (name === Environments.Testing ? Environments.Staging : name).toLowerCase();
